module.exports = __webpack_public_path__ + "img/new-brave-world-background.a44d106a.png";